module.exports = __webpack_public_path__ + "static/img/7.26142de.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/sp/7.png
// module id = 2mPA
// module chunks = 0